import React, { Component } from 'react';
import { CSVLink } from "react-csv";
import map from 'lodash/map';
import get from 'lodash/get';
import has from 'lodash/has';
import moment from 'moment';
import unionBy from 'lodash/unionBy';
import isEmpty from 'lodash/isEmpty';
import './ExportToCsv.css';

class ExportToCSV extends Component { 

  getCreatedByName = (item) => {
    if(!isEmpty(item.firstName) || !isEmpty(item.lastName) && item["firstName"] !== undefined && item["lastName"] !== undefined) {
      return `${item.firstName} ${item.lastName}`
    }
    return 'NA';
  }

  getData = (data) => {
    const { Analytics } = this.props;
    const csvData = [];
    map(data, (d) => {
      let eachUserRow = {
        name: d.name, 
        createdDate: moment(d.createdDate).format('MM/DD/YYYY'),
        createdBy: this.getCreatedByName(d.createdBy),
        category: d.category
      }
      csvData.push(eachUserRow);
    });
    return csvData;
  }

  render() {
    const ChartStaticHeaders = [
      { label: "Chart Name", key: "name" },
      { label: "Date Created", key: "createdDate" },
      { label: "Created By", key: "createdBy" },
      { label: "Chart Category", key: "category" }
    ];
    const { Analytics } = this.props;
    return (
      <div className="col-lg-12 col-md-12 col-sm-12 tool-list-font text-right">
        <span class="linkclass" style={{ lineHeight: '42px' }}><i class="flaticon-export" style={{ marginRight: '8px' }}></i>
          <CSVLink
            data={this.getData(Analytics)}
            headers={ChartStaticHeaders}
            filename={`Charts Analytics-${moment().format("MM/DD/YYYY")}.csv`}
            separator={","}
            target="_blank"
          >Export to CSV</CSVLink>
        </span>
      </div>
    )
  }
}

export default ExportToCSV;